import { z } from 'zod';
import { idSchema } from './api.schema';

export const INVITABLE_ROLES = ['VIEWER', 'EDITOR', 'ADMIN'] as const;
export type InvitableRole = (typeof INVITABLE_ROLES)[number];

export const inviteCreateSchema = z.object({
  role: z.enum(INVITABLE_ROLES),
  expiresInHours: z.number().int().min(1).max(720).default(168),
  maxUses: z.number().int().min(1).max(50).default(1),
});
export type InviteCreateInput = z.input<typeof inviteCreateSchema>;

export const inviteCodeSchema = z.object({
  code: z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[2-9A-HJKMNP-Z]{8,10}$/, 'Kode tidak valid'),
});

export const memberRoleSchema = z.object({ role: z.enum(INVITABLE_ROLES) });

export const transferOwnershipSchema = z.object({ userId: idSchema });

export const joinDecisionSchema = z.object({ approve: z.boolean() });
